import React from "react";
import { useStyles } from "./AboutDetail.styles";

interface Props {}

export const AboutDetail: React.FC<Props> = () => {
  const classes = useStyles();
  return <div className={classes.aboutDetail_root}>About Detail</div>;
};
